import { HTTP, authHeader } from './http-service';

class PersonRegistrationSearchService {
  search(payload) {
    return HTTP.post(`/TrustmarkPersonSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/TrustmarkPersonSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new PersonRegistrationSearchService();
